/**
 * @prettier
 */

import { useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import { onClassAdded } from "../../../services/shared/helpers";
import "react-phone-input-2/lib/style.css";

const PhoneNumberInput = ({
    id,
    onChange,
    error,
    defaultValue,
    label = "",
    initialCountry,
    isRequired = true,
}) => {
    const scrollDown = () => {
        // Scroll down to the bottom of the page when the phone input is opened
        // This is for mobile devices where the keyboard cover the input
        // Using setTimeout to ensure the old safary browser can handle the scroll after the input is focused
        setTimeout(() => {
            const bottomElement = document.getElementById("bottom-anc");
            if (bottomElement) {
                bottomElement.scrollIntoView({
                    top: document.body.scrollHeight,
                    behavior: "smooth",
                    block: "start",
                });
            }
        }, 200);
    };
    useEffect(() => {
        // Scroll down when the phone input is opened
        const targetElem = document.querySelector(".open-phone-input-button");
        onClassAdded(targetElem, "open", scrollDown);
    }, []);

    return (
        <div style={{ position: "relative" }}>
            <>
                <PhoneInput
                    enableSearch
                    disableSearchIcon
                    enableLongNumbers
                    onChange={onChange}
                    value={defaultValue}
                    country={initialCountry ? initialCountry.toLowerCase() : ""}
                    buttonClass="open-phone-input-button"
                    containerClass="phone-input-wrapper"
                    inputProps={{
                        id: id,
                        name: id,
                    }}
                    inputStyle={{
                        paddingLeft: "55px",
                    }}
                    inputClass={`${error ? "error" : ""}`}
                />
                <label
                    className={`phone-input-label ${isRequired ? "required" : ""}`}
                    htmlFor={id}
                    style={{
                        position: "absolute",
                        zIndex: 100000,
                        color: error ? "red" : "#000",
                    }}
                >
                    {label}
                </label>
                {error && (
                    <span role="alert" className="error-text">
                        {error}
                    </span>
                )}
            </>
        </div>
    );
};

export default PhoneNumberInput;
